export const blockedWpPathPrefixes = [
	'/wp-admin',
	'/wp-includes'
];

export const blockedWpExactPaths = [
	'/wp-login.php',
	'/wp-signup.php',
	'/wp-register.php',
	'/wp-activate.php',
	'/wp-comments-post.php',
	'/xmlrpc.php'
];
